import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-99">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-100">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-dark/40 backdrop-blur-sm" data-id="element-101" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.5,
        bounce: 0.3
      }} className="relative w-full max-w-lg bg-white rounded-2xl shadow-apple-hover overflow-hidden flex flex-col max-h-[90vh]" data-id="element-102">
            <div className="flex items-center justify-between p-6 border-b border-pastel-grey-light" data-id="element-103">
              <h2 className="text-xl font-semibold text-dark" data-id="element-104">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-pastel-grey-light transition-colors text-gray-500 hover:text-dark" data-id="element-105">
                <X size={20} data-id="element-106" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto custom-scrollbar" data-id="element-107">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}